import { useState, useCallback, useEffect } from 'react';
import { useFetchAssetRecommendation, getPromptSuggestions, getAdSuggestions } from '@bingads-webui-campaign-react/pmax-landing-utils';

import { STATES } from './use-dynamic-flow-state';
import { formatAdApiErrors } from './format-data';

export const useLoadSuggestions = ({
  currentState,
  triggerTransition,
  website,
  prompt,
  setCacheId,
  logger,
}) => {
  const isLoadingAdSuggestions = currentState === STATES.PREVIEW.LOADING_ADS;

  const [promptSuggestions, setPromptSuggestions] = useState();
  const [adSuggestions, setAdSuggestions] = useState();
  const [errorMessage, setErrorMessage] = useState('');

  const { fetchAssetRecommendation } = useFetchAssetRecommendation();

  const loadAdSuggestions = useCallback(() => {
    logger.trace(`[useLoadSuggestions] Loading ad suggestions. Website: ${website}. Prompt: ${prompt}`);

    return fetchAssetRecommendation({
      website,
      prompt,
    }).then((res) => {
      const { lookupId } = res || {};
      setCacheId(lookupId);

      const formattedAds = getAdSuggestions(res);
      setAdSuggestions(formattedAds);

      setErrorMessage('');

      const { adData } = formattedAds || {};
      const { longHeadline } = adData || {};
      const formattedPrompts = getPromptSuggestions(res);
      const filteredPrompts
        = formattedPrompts.filter(s => s.toLowerCase().indexOf(longHeadline.toLowerCase()) === -1);
      setPromptSuggestions(filteredPrompts);

      logger.trace(`[useLoadSuggestions] Loaded ad suggestions. Ad suggestions: ${JSON.stringify(formattedAds)}. Prompt suggestions: ${JSON.stringify(filteredPrompts)}`);
    }).catch((err) => {
      const { responseJSON } = err;
      const { status } = responseJSON || {};
      logger.trace(`[useLoadSuggestions] Error loading ad suggestions. Error: ${JSON.stringify(responseJSON || err)}`);
      const apiErrorMsg = formatAdApiErrors(status);
      setErrorMessage(apiErrorMsg);
    }).finally(() => {
      triggerTransition();
    });
  }, [fetchAssetRecommendation, logger, prompt, setCacheId, triggerTransition, website]);

  useEffect(() => {
    if (isLoadingAdSuggestions) {
      loadAdSuggestions();
    }
  }, [isLoadingAdSuggestions, loadAdSuggestions]);

  return {
    promptSuggestions,
    adSuggestions,
    errorMessage,
  };
};

